// import React, { useState, useRef } from 'react';
// import { useModal } from '../../context/ModalContext';
// import { getInitials, getRandomColor, formatPhoneNumber } from '../../utils/helpers';
// import {
//   exportToCSV,
//   exportToJSON,
//   exportToExcel,
//   exportToPDF,
//   formatForExport,
//   getExportFilename
// } from '../../utils/exportUtils';

// const Profile = ({ showToast }) => {
//   // User state
//   const [user, setUser] = useState({
//     id: 1,
//     name: 'Rev. James Mensah',
//     email: 'james@gracechapel.org',
//     phone: '+233244000001',
//     role: 'Super Admin',
//     church: 'Grace Chapel International',
//     joined: 'January 2024',
//     lastActive: 'Today at 10:30 AM',
//     status: 'Active',
//     avatar: null,
//     bio: 'Senior Pastor with over 15 years of ministry experience. Passionate about church growth and digital evangelism.',
//     preferences: {
//       language: 'English',
//       timezone: 'GMT',
//       dateFormat: 'MM/DD/YYYY',
//       notifications: {
//         email: true,
//         sms: true,
//         push: true
//       }
//     },
//     security: {
//       twoFactorEnabled: false,
//       lastPasswordChange: '2026-01-15',
//       loginHistory: [
//         { date: '2026-04-23 10:30:00', ip: '192.168.1.1', device: 'Chrome - Windows', location: 'Accra, Ghana' },
//         { date: '2026-04-22 15:20:00', ip: '192.168.1.2', device: 'Safari - iPhone', location: 'Accra, Ghana' },
//         { date: '2026-04-21 09:15:00', ip: '192.168.1.3', device: 'Firefox - Mac', location: 'Tema, Ghana' }
//       ]
//     },
//     activityLog: [
//       { id: 1, action: 'Logged in', timestamp: '2026-04-23 10:30:00', details: 'IP: 192.168.1.1' },
//       { id: 2, action: 'Sent broadcast', timestamp: '2026-04-23 09:15:00', details: 'Sunday reminder to 1,247 members' },
//       { id: 3, action: 'Updated member', timestamp: '2026-04-22 16:45:00', details: 'Edited Emmanuel Asante' },
//       { id: 4, action: 'Created poll', timestamp: '2026-04-22 14:30:00', details: 'Service feedback poll' },
//       { id: 5, action: 'Exported members', timestamp: '2026-04-21 11:20:00', details: 'Exported 124 members' }
//     ],
//     stats: {
//       totalBroadcasts: 47,
//       totalMembers: 1247,
//       totalSMS: 68241,
//       campaigns: 12
//     }
//   });

//   // Edit form refs
//   const editNameRef = useRef(null);
//   const editEmailRef = useRef(null);
//   const editPhoneRef = useRef(null);
//   const editBioRef = useRef(null);
//   const editLanguageRef = useRef(null);
//   const editTimezoneRef = useRef(null);
//   const editDateFormatRef = useRef(null);

//   // Password change refs
//   const currentPasswordRef = useRef(null);
//   const newPasswordRef = useRef(null);
//   const confirmPasswordRef = useRef(null);

//   // State for editing
//   const [editingField, setEditingField] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [activeTab, setActiveTab] = useState('profile');
//   const [showActivity, setShowActivity] = useState(true);

//   const { openModal, closeModal } = useModal();

//   const color = getRandomColor(user.id);

//   // ==================== PROFILE ACTIONS ====================

//   // Update profile
//   const handleUpdateProfile = () => {
//     setIsEditing(true);
//     openModal(
//       <div>
//         <div className="modal-header">
//           <div className="modal-title">✏️ Edit Profile</div>
//           <button className="modal-close" onClick={closeModal}>×</button>
//         </div>
//         <div className="modal-body">
//           <div style={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             gap: '16px',
//             marginBottom: '16px',
//             padding: '16px',
//             background: 'var(--cream)',
//             borderRadius: '10px'
//           }}>
//             <div style={{ 
//               width: '64px', 
//               height: '64px', 
//               borderRadius: '50%', 
//               background: color,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: '24px',
//               fontWeight: '700',
//               color: 'white',
//               flexShrink: 0
//             }}>
//               {getInitials(user.name)}
//             </div>
//             <div>
//               <div style={{ fontSize: '13px', color: 'var(--text-light)' }}>Profile Photo</div>
//               <button 
//                 className="btn btn-ghost btn-sm" 
//                 onClick={() => showToast('📸 Photo upload modal opening...', 'info')}
//               >
//                 📸 Change Photo
//               </button>
//             </div>
//           </div>

//           <div className="form-group">
//             <label className="form-label">Full Name</label>
//             <input 
//               className="form-input" 
//               ref={editNameRef}
//               defaultValue={user.name}
//             />
//           </div>
//           <div className="form-group">
//             <label className="form-label">Email Address</label>
//             <input 
//               className="form-input" 
//               type="email"
//               ref={editEmailRef}
//               defaultValue={user.email}
//             />
//           </div>
//           <div className="form-group">
//             <label className="form-label">Phone Number</label>
//             <input 
//               className="form-input" 
//               ref={editPhoneRef}
//               defaultValue={user.phone}
//             />
//           </div>
//           <div className="form-group">
//             <label className="form-label">Bio</label>
//             <textarea 
//               className="form-textarea" 
//               rows="3"
//               ref={editBioRef}
//               defaultValue={user.bio}
//             />
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label className="form-label">Language</label>
//               <select 
//                 className="form-select" 
//                 ref={editLanguageRef}
//                 defaultValue={user.preferences.language}
//               >
//                 <option value="English">English</option>
//                 <option value="French">French</option>
//                 <option value="Spanish">Spanish</option>
//                 <option value="Portuguese">Portuguese</option>
//               </select>
//             </div>
//             <div className="form-group">
//               <label className="form-label">Time Zone</label>
//               <select 
//                 className="form-select" 
//                 ref={editTimezoneRef}
//                 defaultValue={user.preferences.timezone}
//               >
//                 <option value="GMT">GMT (UTC+0)</option>
//                 <option value="GMT+1">GMT+1 (WAT)</option>
//                 <option value="GMT+2">GMT+2 (CAT)</option>
//                 <option value="GMT+3">GMT+3 (EAT)</option>
//                 <option value="GMT-5">GMT-5 (EST)</option>
//               </select>
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Date Format</label>
//             <select 
//               className="form-select" 
//               ref={editDateFormatRef}
//               defaultValue={user.preferences.dateFormat}
//             >
//               <option value="MM/DD/YYYY">MM/DD/YYYY</option>
//               <option value="DD/MM/YYYY">DD/MM/YYYY</option>
//               <option value="YYYY-MM-DD">YYYY-MM-DD</option>
//             </select>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={closeModal}>Cancel</button>
//           <button 
//             className="btn btn-gold" 
//             onClick={() => {
//               const name = editNameRef.current?.value?.trim() || '';
//               const email = editEmailRef.current?.value?.trim() || '';
//               const phone = editPhoneRef.current?.value?.trim() || '';
//               const bio = editBioRef.current?.value || '';
//               const language = editLanguageRef.current?.value || 'English';
//               const timezone = editTimezoneRef.current?.value || 'GMT';
//               const dateFormat = editDateFormatRef.current?.value || 'MM/DD/YYYY';

//               if (!name) {
//                 showToast('Please enter your name', 'error');
//                 return;
//               }
//               if (!email) {
//                 showToast('Please enter your email', 'error');
//                 return;
//               }

//               setUser({
//                 ...user,
//                 name,
//                 email,
//                 phone,
//                 bio,
//                 preferences: {
//                   ...user.preferences,
//                   language,
//                   timezone,
//                   dateFormat
//                 }
//               });
//               showToast('✅ Profile updated successfully!', 'success');
//               setEditingField(null);
//               setIsEditing(false);
//               closeModal();
//             }}
//           >
//             💾 Save Changes
//           </button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== PASSWORD ACTIONS ====================

//   const handleChangePassword = () => {
//     openModal(
//       <div>
//         <div className="modal-header">
//           <div className="modal-title">🔑 Change Password</div>
//           <button className="modal-close" onClick={closeModal}>×</button>
//         </div>
//         <div className="modal-body">
//           <div className="form-group">
//             <label className="form-label">Current Password</label>
//             <input 
//               className="form-input" 
//               type="password"
//               ref={currentPasswordRef}
//               placeholder="Enter your current password"
//             />
//           </div>
//           <div className="form-group">
//             <label className="form-label">New Password</label>
//             <input 
//               className="form-input" 
//               type="password"
//               ref={newPasswordRef}
//               placeholder="Enter new password"
//             />
//             <div className="form-hint">Minimum 8 characters with at least one number and special character</div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Confirm New Password</label>
//             <input 
//               className="form-input" 
//               type="password"
//               ref={confirmPasswordRef}
//               placeholder="Confirm new password"
//             />
//           </div>
//           <div style={{ 
//             padding: '12px', 
//             background: 'var(--blue-bg)', 
//             borderRadius: '8px', 
//             fontSize: '12px', 
//             color: 'var(--blue)' 
//           }}>
//             🔒 Your password will be securely encrypted.
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={closeModal}>Cancel</button>
//           <button 
//             className="btn btn-gold" 
//             onClick={() => {
//               const current = currentPasswordRef.current?.value || '';
//               const newPass = newPasswordRef.current?.value || '';
//               const confirm = confirmPasswordRef.current?.value || '';

//               if (!current) {
//                 showToast('Please enter your current password', 'error');
//                 return;
//               }
//               if (newPass.length < 8) {
//                 showToast('Password must be at least 8 characters', 'error');
//                 return;
//               }
//               if (newPass !== confirm) {
//                 showToast('Passwords do not match', 'error');
//                 return;
//               }

//               showToast('✅ Password changed successfully!', 'success');
//               setUser({
//                 ...user,
//                 security: {
//                   ...user.security,
//                   lastPasswordChange: new Date().toISOString().split('T')[0]
//                 }
//               });
//               closeModal();
//             }}
//           >
//             🔑 Change Password
//           </button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== TWO-FACTOR AUTHENTICATION ====================

//   const handleToggle2FA = () => {
//     const isEnabled = user.security.twoFactorEnabled;
//     openModal(
//       <div>
//         <div className="modal-header">
//           <div className="modal-title">{isEnabled ? '🔒' : '🔓'} Two-Factor Authentication</div>
//           <button className="modal-close" onClick={closeModal}>×</button>
//         </div>
//         <div className="modal-body">
//           <div style={{ 
//             textAlign: 'center',
//             padding: '20px 0'
//           }}>
//             <div style={{ fontSize: '48px', marginBottom: '12px' }}>
//               {isEnabled ? '🔒' : '🔓'}
//             </div>
//             <div style={{ fontSize: '18px', fontWeight: '600', color: 'var(--navy)' }}>
//               {isEnabled ? 'Disable Two-Factor Authentication?' : 'Enable Two-Factor Authentication?'}
//             </div>
//             <p style={{ fontSize: '13px', color: 'var(--text-mid)', marginTop: '8px' }}>
//               {isEnabled 
//                 ? 'This will remove an extra layer of security from your account.'
//                 : 'This will add an extra layer of security to your account.'}
//             </p>
//             <div style={{ 
//               marginTop: '16px',
//               padding: '12px',
//               background: isEnabled ? 'var(--red-bg)' : 'var(--green-bg)',
//               borderRadius: '8px',
//               fontSize: '13px',
//               color: isEnabled ? 'var(--red)' : 'var(--green)'
//             }}>
//               {isEnabled 
//                 ? '⚠️ Your account will be less secure without 2FA.'
//                 : '✅ You will need to verify your identity using an authenticator app.'}
//             </div>
//           </div>
//           <div className="form-group">
//             <label className="form-label">Phone Number (for SMS verification)</label>
//             <input 
//               className="form-input" 
//               defaultValue={user.phone}
//               placeholder="+233244123456"
//             />
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={closeModal}>Cancel</button>
//           <button 
//             className={`btn ${isEnabled ? 'btn-danger' : 'btn-gold'}`} 
//             onClick={() => {
//               setUser({
//                 ...user,
//                 security: {
//                   ...user.security,
//                   twoFactorEnabled: !isEnabled
//                 }
//               });
//               showToast(isEnabled ? '🔒 2FA disabled' : '🔒 2FA enabled', 'success');
//               closeModal();
//             }}
//           >
//             {isEnabled ? 'Disable 2FA' : 'Enable 2FA'}
//           </button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== NOTIFICATION PREFERENCES ====================

//   const handleNotificationToggle = (type) => {
//     setUser({
//       ...user,
//       preferences: {
//         ...user.preferences,
//         notifications: {
//           ...user.preferences.notifications,
//           [type]: !user.preferences.notifications[type]
//         }
//       }
//     });
//     showToast(`🔔 ${type.charAt(0).toUpperCase() + type.slice(1)} notifications ${user.preferences.notifications[type] ? 'disabled' : 'enabled'}`, 'info');
//   };

//   // ==================== EXPORT ACTIONS ====================

//   const handleExportData = () => {
//     const data = {
//       profile: {
//         name: user.name,
//         email: user.email,
//         phone: user.phone,
//         role: user.role,
//         church: user.church,
//         joined: user.joined,
//         status: user.status,
//         bio: user.bio
//       },
//       preferences: user.preferences,
//       security: {
//         twoFactorEnabled: user.security.twoFactorEnabled,
//         lastPasswordChange: user.security.lastPasswordChange
//       },
//       stats: user.stats,
//       activityLog: user.activityLog
//     };

//     const fields = [
//       { key: 'name', label: 'Name' },
//       { key: 'email', label: 'Email' },
//       { key: 'phone', label: 'Phone' },
//       { key: 'role', label: 'Role' },
//       { key: 'church', label: 'Church' },
//       { key: 'joined', label: 'Joined' },
//       { key: 'status', label: 'Status' },
//       { key: 'totalBroadcasts', label: 'Total Broadcasts' },
//       { key: 'totalMembers', label: 'Total Members' },
//       { key: 'totalSMS', label: 'Total SMS' },
//       { key: 'campaigns', label: 'Campaigns' }
//     ];

//     const exportData = [{
//       ...data.profile,
//       ...data.stats
//     }];

//     openModal(
//       <div>
//         <div className="modal-header">
//           <div className="modal-title">📥 Export Profile Data</div>
//           <button className="modal-close" onClick={closeModal}>×</button>
//         </div>
//         <div className="modal-body">
//           <div style={{ fontSize: '13px', color: 'var(--text-mid)', marginBottom: '16px' }}>
//             Export your profile data and statistics.
//           </div>
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
//             {['CSV', 'JSON', 'Excel', 'PDF'].map(format => (
//               <button
//                 key={format}
//                 className="btn btn-ghost btn-sm"
//                 onClick={() => {
//                   const formattedData = formatForExport(exportData, fields);
//                   const filename = getExportFilename('user-profile');
                  
//                   switch (format) {
//                     case 'CSV':
//                       exportToCSV(formattedData, filename);
//                       break;
//                     case 'JSON':
//                       exportToJSON(data, filename);
//                       break;
//                     case 'Excel':
//                       exportToExcel(formattedData, filename);
//                       break;
//                     case 'PDF':
//                       exportToPDF(formattedData, 'User Profile Report', filename);
//                       break;
//                     default:
//                       showToast('Export format not supported', 'error');
//                       return;
//                   }
//                   showToast(`📥 Profile exported as ${format}!`, 'success');
//                   closeModal();
//                 }}
//                 style={{ 
//                   padding: '8px', 
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                   gap: '4px',
//                   height: 'auto',
//                   border: '2px solid var(--border)',
//                   borderRadius: '8px',
//                   transition: 'all 0.2s',
//                   cursor: 'pointer'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.borderColor = 'var(--gold)';
//                   e.currentTarget.style.background = 'var(--gold-pale)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.borderColor = 'var(--border)';
//                   e.currentTarget.style.background = 'transparent';
//                 }}
//               >
//                 <span style={{ fontSize: '20px' }}>
//                   {format === 'CSV' && '📊'}
//                   {format === 'JSON' && '📋'}
//                   {format === 'Excel' && '📈'}
//                   {format === 'PDF' && '📄'}
//                 </span>
//                 <span style={{ fontSize: '11px' }}>{format}</span>
//               </button>
//             ))}
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={closeModal}>Cancel</button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== ACTIVITY LOG ACTIONS ====================

//   const handleViewActivityDetails = (activity) => {
//     openModal(
//       <div>
//         <div className="modal-header">
//           <div className="modal-title">📋 Activity Details</div>
//           <button className="modal-close" onClick={closeModal}>×</button>
//         </div>
//         <div className="modal-body">
//           <div style={{ display: 'grid', gap: '12px' }}>
//             <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px', fontSize: '13px' }}>
//               <span style={{ color: 'var(--text-light)', fontWeight: '500' }}>Action</span>
//               <span style={{ fontWeight: '600' }}>{activity.action}</span>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px', fontSize: '13px' }}>
//               <span style={{ color: 'var(--text-light)', fontWeight: '500' }}>Time</span>
//               <span>{activity.timestamp}</span>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px', fontSize: '13px' }}>
//               <span style={{ color: 'var(--text-light)', fontWeight: '500' }}>Details</span>
//               <span style={{ color: 'var(--text-mid)' }}>{activity.details}</span>
//             </div>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={closeModal}>Close</button>
//         </div>
//       </div>
//     );
//   };

//   const handleClearActivity = () => {
//     openModal(
//       <div>
//         <div className="modal-header">
//           <div className="modal-title">🗑️ Clear Activity Log</div>
//           <button className="modal-close" onClick={closeModal}>×</button>
//         </div>
//         <div className="modal-body">
//           <p style={{ fontSize: '14px', color: 'var(--text-mid)', marginBottom: '16px' }}>
//             Are you sure you want to clear your activity log?
//           </p>
//           <div style={{ 
//             padding: '12px', 
//             background: 'var(--red-bg)', 
//             borderRadius: '8px', 
//             fontSize: '13px', 
//             color: 'var(--red)' 
//           }}>
//             ⚠️ This action cannot be undone.
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={closeModal}>Cancel</button>
//           <button 
//             className="btn btn-danger" 
//             onClick={() => {
//               setUser({
//                 ...user,
//                 activityLog: []
//               });
//               showToast('🗑️ Activity log cleared', 'error');
//               closeModal();
//             }}
//           >
//             Clear All
//           </button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== DEACTIVATE ACCOUNT ====================

//   const handleDeactivateAccount = () => {
//     openModal(
//       <div>
//         <div className="modal-header">
//           <div className="modal-title">⚠️ Deactivate Account</div>
//           <button className="modal-close" onClick={closeModal}>×</button>
//         </div>
//         <div className="modal-body">
//           <div style={{ 
//             textAlign: 'center',
//             padding: '20px 0'
//           }}>
//             <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
//             <div style={{ fontSize: '18px', fontWeight: '600', color: 'var(--red)' }}>
//               Are you sure you want to deactivate your account?
//             </div>
//             <p style={{ fontSize: '14px', color: 'var(--text-mid)', marginTop: '8px' }}>
//               Your account will be temporarily disabled. You can reactivate it at any time.
//             </p>
//             <div style={{ 
//               marginTop: '16px',
//               padding: '12px',
//               background: 'var(--red-bg)',
//               borderRadius: '8px',
//               fontSize: '13px',
//               color: 'var(--red)'
//             }}>
//               ⚠️ You will not be able to access the platform until reactivated.
//             </div>
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={closeModal}>Cancel</button>
//           <button 
//             className="btn btn-danger" 
//             onClick={() => {
//               setUser({
//                 ...user,
//                 status: 'Inactive'
//               });
//               showToast('⚠️ Account deactivated', 'error');
//               closeModal();
//             }}
//           >
//             Deactivate Account
//           </button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== LOGIN HISTORY ====================

//   const handleViewLoginHistory = () => {
//     openModal(
//       <div>
//         <div className="modal-header">
//           <div className="modal-title">🕐 Login History</div>
//           <button className="modal-close" onClick={closeModal}>×</button>
//         </div>
//         <div className="modal-body">
//           <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
//             {user.security.loginHistory.map((login, index) => (
//               <div key={index} style={{ 
//                 padding: '10px', 
//                 borderBottom: '1px solid var(--border-light)',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 flexWrap: 'wrap',
//                 gap: '8px'
//               }}>
//                 <div>
//                   <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
//                     {login.device}
//                   </div>
//                   <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
//                     {login.location} · {login.ip}
//                   </div>
//                 </div>
//                 <div style={{ fontSize: '12px', color: 'var(--text-mid)', textAlign: 'right' }}>
//                   {login.date}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="modal-footer">
//           <button className="btn btn-ghost" onClick={closeModal}>Close</button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== EXPORT ACTIVITY ====================

//   const handleExportActivity = () => {
//     if (user.activityLog.length === 0) {
//       showToast('No activity to export', 'error');
//       return;
//     }

//     const fields = [
//       { key: 'action', label: 'Action' },
//       { key: 'timestamp', label: 'Timestamp' },
//       { key: 'details', label: 'Details' }
//     ];

//     const formattedData = formatForExport(user.activityLog, fields);
//     const filename = getExportFilename('user-activity');
//     exportToCSV(formattedData, filename);
//     showToast(`📥 ${user.activityLog.length} activities exported`, 'success');
//   };

//   return (
//     <div className="grid-2" style={{ gap: '20px' }}>
//       {/* Left Column - Profile Card */}
//       <div>
//         <div className="card">
//           <div className="card-header">
//             <div className="card-title">Profile</div>
//             <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
//               <button className="btn btn-ghost btn-sm" onClick={handleExportData}>
//                 📥 Export
//               </button>
//               <button className="btn btn-gold btn-sm" onClick={handleUpdateProfile}>
//                 ✏️ Edit
//               </button>
//             </div>
//           </div>

//           {/* Profile Header */}
//           <div style={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             gap: '16px',
//             padding: '16px',
//             background: 'var(--cream)',
//             borderRadius: '10px',
//             marginBottom: '16px'
//           }}>
//             <div style={{ 
//               width: '80px', 
//               height: '80px', 
//               borderRadius: '50%', 
//               background: color,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontSize: '32px',
//               fontWeight: '700',
//               color: 'white',
//               flexShrink: 0
//             }}>
//               {getInitials(user.name)}
//             </div>
//             <div style={{ flex: 1 }}>
//               <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--navy)' }}>
//                 {user.name}
//               </div>
//               <div style={{ fontSize: '13px', color: 'var(--text-mid)' }}>
//                 {user.role} · {user.church}
//               </div>
//               <div style={{ display: 'flex', gap: '8px', marginTop: '4px', flexWrap: 'wrap' }}>
//                 <span className={`badge ${user.status === 'Active' ? 'badge-green' : 'badge-red'}`}>
//                   {user.status}
//                 </span>
//                 <span className="badge badge-blue">
//                   Last active: {user.lastActive}
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Profile Details */}
//           <div style={{ marginBottom: '16px' }}>
//             <div style={{ 
//               display: 'grid', 
//               gridTemplateColumns: '1fr 1fr', 
//               gap: '10px'
//             }}>
//               {[
//                 ['📧 Email', user.email],
//                 ['📞 Phone', formatPhoneNumber(user.phone)],
//                 ['⛪ Church', user.church],
//                 ['📅 Joined', user.joined],
//                 ['🔑 Role', user.role],
//                 ['🕐 Last Active', user.lastActive]
//               ].map(([icon, value]) => (
//                 <div key={icon} style={{ 
//                   padding: '10px 12px', 
//                   background: 'var(--cream)', 
//                   borderRadius: '8px'
//                 }}>
//                   <div style={{ fontSize: '10px', color: 'var(--text-light)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
//                     {icon}
//                   </div>
//                   <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)', marginTop: '2px' }}>
//                     {value}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Bio */}
//           <div style={{ 
//             padding: '12px', 
//             background: 'var(--cream)', 
//             borderRadius: '8px',
//             marginBottom: '16px'
//           }}>
//             <div style={{ fontSize: '11px', color: 'var(--text-light)', marginBottom: '4px', fontWeight: '600' }}>
//               📝 Bio
//             </div>
//             <div style={{ fontSize: '13px', color: 'var(--text-mid)', lineHeight: '1.6' }}>
//               {user.bio}
//             </div>
//           </div>

//           {/* Quick Actions */}
//           <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
//             <button className="btn btn-ghost btn-sm" onClick={handleChangePassword}>
//               🔑 Change Password
//             </button>
//             <button className="btn btn-ghost btn-sm" onClick={handleToggle2FA}>
//               {user.security.twoFactorEnabled ? '🔒' : '🔓'} {user.security.twoFactorEnabled ? '2FA On' : '2FA Off'}
//             </button>
//             <button className="btn btn-danger btn-sm" onClick={handleDeactivateAccount}>
//               ⚠️ Deactivate
//             </button>
//           </div>
//         </div>

//         {/* Stats */}
//         <div className="card" style={{ marginTop: '16px' }}>
//           <div className="card-title" style={{ marginBottom: '14px' }}>📊 Statistics</div>
//           <div className="stats-grid" style={{ gap: '10px' }}>
//             <div className="stat-card gold" style={{ padding: '12px' }}>
//               <div className="stat-label">Broadcasts</div>
//               <div className="stat-value">{user.stats.totalBroadcasts}</div>
//               <div className="stat-icon">📢</div>
//             </div>
//             <div className="stat-card green" style={{ padding: '12px' }}>
//               <div className="stat-label">Members</div>
//               <div className="stat-value">{user.stats.totalMembers.toLocaleString()}</div>
//               <div className="stat-icon">👥</div>
//             </div>
//             <div className="stat-card blue" style={{ padding: '12px' }}>
//               <div className="stat-label">SMS Sent</div>
//               <div className="stat-value">{user.stats.totalSMS.toLocaleString()}</div>
//               <div className="stat-icon">📨</div>
//             </div>
//             <div className="stat-card purple" style={{ padding: '12px' }}>
//               <div className="stat-label">Campaigns</div>
//               <div className="stat-value">{user.stats.campaigns}</div>
//               <div className="stat-icon">🚀</div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Right Column - Settings & Activity */}
//       <div>
//         {/* Notification Preferences */}
//         <div className="card" style={{ marginBottom: '16px' }}>
//           <div className="card-title" style={{ marginBottom: '14px' }}>🔔 Notification Preferences</div>
//           {[
//             { key: 'email', label: 'Email Notifications', icon: '📧' },
//             { key: 'sms', label: 'SMS Notifications', icon: '📱' },
//             { key: 'push', label: 'Push Notifications', icon: '🔔' }
//           ].map((item) => (
//             <div key={item.key} style={{ 
//               display: 'flex', 
//               alignItems: 'center', 
//               justifyContent: 'space-between', 
//               padding: '10px 0',
//               borderBottom: '1px solid var(--border-light)'
//             }}>
//               <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                 <span style={{ fontSize: '20px' }}>{item.icon}</span>
//                 <span style={{ fontSize: '13px', color: 'var(--text)' }}>{item.label}</span>
//               </div>
//               <label className="toggle">
//                 <input 
//                   type="checkbox" 
//                   checked={user.preferences.notifications[item.key]}
//                   onChange={() => handleNotificationToggle(item.key)}
//                 />
//                 <span className="toggle-slider"></span>
//               </label>
//             </div>
//           ))}
//           <div style={{ marginTop: '12px' }}>
//             <button className="btn btn-ghost btn-sm" onClick={() => {
//               setUser({
//                 ...user,
//                 preferences: {
//                   ...user.preferences,
//                   notifications: {
//                     email: true,
//                     sms: true,
//                     push: true
//                   }
//                 }
//               });
//               showToast('✅ All notifications enabled', 'success');
//             }}>
//               Enable All
//             </button>
//             <button className="btn btn-ghost btn-sm" style={{ marginLeft: '8px' }} onClick={() => {
//               setUser({
//                 ...user,
//                 preferences: {
//                   ...user.preferences,
//                   notifications: {
//                     email: false,
//                     sms: false,
//                     push: false
//                   }
//                 }
//               });
//               showToast('🔕 All notifications disabled', 'info');
//             }}>
//               Disable All
//             </button>
//           </div>
//         </div>

//         {/* Security */}
//         <div className="card" style={{ marginBottom: '16px' }}>
//           <div className="card-title" style={{ marginBottom: '14px' }}>🔐 Security</div>
//           <div style={{ display: 'grid', gap: '10px' }}>
//             <div style={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               padding: '10px 12px',
//               background: 'var(--cream)',
//               borderRadius: '8px'
//             }}>
//               <div>
//                 <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
//                   Two-Factor Authentication
//                 </div>
//                 <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
//                   {user.security.twoFactorEnabled ? '✅ Enabled' : '❌ Disabled'}
//                 </div>
//               </div>
//               <button className="btn btn-ghost btn-sm" onClick={handleToggle2FA}>
//                 {user.security.twoFactorEnabled ? 'Disable' : 'Enable'}
//               </button>
//             </div>
//             <div style={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               padding: '10px 12px',
//               background: 'var(--cream)',
//               borderRadius: '8px'
//             }}>
//               <div>
//                 <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
//                   Last Password Change
//                 </div>
//                 <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
//                   {user.security.lastPasswordChange}
//                 </div>
//               </div>
//               <button className="btn btn-ghost btn-sm" onClick={handleChangePassword}>
//                 Change
//               </button>
//             </div>
//             <div style={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center',
//               padding: '10px 12px',
//               background: 'var(--cream)',
//               borderRadius: '8px'
//             }}>
//               <div>
//                 <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
//                   Login History
//                 </div>
//                 <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
//                   {user.security.loginHistory.length} sessions
//                 </div>
//               </div>
//               <button className="btn btn-ghost btn-sm" onClick={handleViewLoginHistory}>
//                 View All
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Activity Log */}
//         <div className="card">
//           <div className="card-header">
//             <div className="card-title">📋 Activity Log</div>
//             <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
//               {user.activityLog.length > 0 && (
//                 <>
//                   <button className="btn btn-ghost btn-sm" onClick={handleExportActivity}>
//                     📥 Export
//                   </button>
//                   <button className="btn btn-ghost btn-sm" onClick={handleClearActivity} style={{ color: 'var(--red)' }}>
//                     🗑️ Clear
//                   </button>
//                 </>
//               )}
//             </div>
//           </div>
//           {user.activityLog.length === 0 ? (
//             <div style={{ textAlign: 'center', padding: '30px 0', color: 'var(--text-light)' }}>
//               <div style={{ fontSize: '40px', marginBottom: '8px' }}>📭</div>
//               <div>No activity yet</div>
//             </div>
//           ) : (
//             <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
//               {user.activityLog.slice(0, 5).map((activity) => (
//                 <div key={activity.id} style={{ 
//                   display: 'flex', 
//                   alignItems: 'center', 
//                   gap: '10px',
//                   padding: '10px 0',
//                   borderBottom: '1px solid var(--border-light)',
//                   cursor: 'pointer'
//                 }}
//                 onMouseEnter={(e) => e.currentTarget.style.background = 'var(--cream)'}
//                 onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                 onClick={() => handleViewActivityDetails(activity)}
//                 >
//                   <div style={{ 
//                     width: '32px', 
//                     height: '32px', 
//                     borderRadius: '50%', 
//                     background: 'var(--navy)',
//                     color: 'var(--gold-light)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     fontSize: '14px',
//                     flexShrink: 0
//                   }}>
//                     {activity.action.charAt(0)}
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
//                       {activity.action}
//                     </div>
//                     <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
//                       {activity.timestamp}
//                     </div>
//                   </div>
//                   <button 
//                     className="btn btn-ghost btn-sm btn-icon"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleViewActivityDetails(activity);
//                     }}
//                     title="View Details"
//                   >
//                     👁
//                   </button>
//                 </div>
//               ))}
//               {user.activityLog.length > 5 && (
//                 <div style={{ textAlign: 'center', padding: '8px 0' }}>
//                   <button 
//                     className="btn btn-ghost btn-sm" 
//                     onClick={() => {
//                       openModal(
//                         <div>
//                           <div className="modal-header">
//                             <div className="modal-title">📋 All Activities</div>
//                             <button className="modal-close" onClick={closeModal}>×</button>
//                           </div>
//                           <div className="modal-body">
//                             <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
//                               {user.activityLog.map((activity) => (
//                                 <div key={activity.id} style={{ 
//                                   padding: '10px', 
//                                   borderBottom: '1px solid var(--border-light)',
//                                   cursor: 'pointer'
//                                 }}
//                                 onClick={() => {
//                                   closeModal();
//                                   setTimeout(() => handleViewActivityDetails(activity), 100);
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.background = 'var(--cream)'}
//                                 onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
//                                 >
//                                   <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
//                                     {activity.action}
//                                   </div>
//                                   <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
//                                     {activity.timestamp}
//                                   </div>
//                                   <div style={{ fontSize: '11px', color: 'var(--text-mid)' }}>
//                                     {activity.details}
//                                   </div>
//                                 </div>
//                               ))}
//                             </div>
//                           </div>
//                           <div className="modal-footer">
//                             <button className="btn btn-ghost" onClick={closeModal}>Close</button>
//                             {user.activityLog.length > 0 && (
//                               <button className="btn btn-ghost" onClick={handleExportActivity}>
//                                 📥 Export All
//                               </button>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     }}
//                   >
//                     View All ({user.activityLog.length})
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       <style>{`
//         .badge {
//           padding: 3px 10px;
//           border-radius: 12px;
//           font-size: 11px;
//           font-weight: 500;
//           display: inline-block;
//         }
//         .badge-green {
//           background: var(--green-bg);
//           color: var(--green);
//         }
//         .badge-red {
//           background: var(--red-bg);
//           color: var(--red);
//         }
//         .badge-blue {
//           background: var(--blue-bg);
//           color: var(--blue);
//         }
//         .badge-amber {
//           background: var(--amber-bg);
//           color: var(--amber);
//         }
//         .card-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 16px;
//           flex-wrap: wrap;
//           gap: 10px;
//         }
//         .stats-grid {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 10px;
//         }
//         .stat-card {
//           padding: 12px;
//           border-radius: 10px;
//           position: relative;
//           overflow: hidden;
//         }
//         .stat-card .stat-label {
//           font-size: 11px;
//           color: var(--text-light);
//           font-weight: 500;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
//         .stat-card .stat-value {
//           font-size: 20px;
//           font-weight: 700;
//           font-family: Playfair Display, serif;
//           color: var(--navy);
//           margin-top: 2px;
//         }
//         .stat-card .stat-icon {
//           position: absolute;
//           right: 12px;
//           top: 50%;
//           transform: translateY(-50%);
//           font-size: 28px;
//           opacity: 0.3;
//         }
//         .stat-card.gold { background: var(--gold-pale); }
//         .stat-card.green { background: var(--green-bg); }
//         .stat-card.blue { background: var(--blue-bg); }
//         .stat-card.purple { background: var(--purple-bg); }
//         @media (max-width: 768px) {
//           .grid-2 {
//             grid-template-columns: 1fr !important;
//           }
//           .stats-grid {
//             grid-template-columns: repeat(2, 1fr);
//           }
//           .card-header {
//             flex-direction: column;
//             align-items: flex-start !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Profile;














import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../context/ModalContext';
import { getInitials, getRandomColor, formatPhoneNumber } from '../../utils/helpers';
import {
  exportToCSV,
  exportToJSON,
  exportToExcel,
  exportToPDF,
  formatForExport,
  getExportFilename
} from '../../utils/exportUtils';
import {
  selectCurrentUser,
  selectCurrentOrganization,
  selectUserName,
  selectUserEmail,
  selectUserRole,
  selectUserPermissions,
  selectLoginCount,
  selectAuthToken,
  selectAuthLoading,
  selectApiMessage,
  selectAuthError,
  selectAuthSuccess,
  updateProfile,
  changePassword,
  toggleTwoFactor,
  logoutUser,
  clearAuthState,
  clearApiMessage,
  clearError,
  getCurrentUser
} from '../../store/slices/authSlice';
import {
  Pencil, Camera, Loader2, Save, Key, Lock, Unlock, AlertTriangle, CheckCircle2,
  XCircle, Bell, Download, BarChart3, ClipboardList, TrendingUp, FileText,
  Trash2, Clock, LogOut, Hand, Mail, Phone, Church, Calendar, NotebookPen,
  Megaphone, Users, Send, Rocket, Smartphone, Eye, Inbox, ShieldCheck
} from 'lucide-react';

const Profile = ({ showToast }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { openModal, closeModal } = useModal();

  // Get user from Redux store
  const currentUser = useSelector(selectCurrentUser);
  const organization = useSelector(selectCurrentOrganization);
  const userName = useSelector(selectUserName);
  const userEmail = useSelector(selectUserEmail);
  const userRole = useSelector(selectUserRole);
  const permissions = useSelector(selectUserPermissions);
  const loginCount = useSelector(selectLoginCount);
  const authToken = useSelector(selectAuthToken);
  const isLoading = useSelector(selectAuthLoading);
  const apiMessage = useSelector(selectApiMessage);
  const authError = useSelector(selectAuthError);
  const authSuccess = useSelector(selectAuthSuccess);

  // Debug log
  console.log('🔍 Profile - Current user from Redux:', currentUser);

  // Initialize user state with data from Redux
  const [user, setUser] = useState({
    id: currentUser?.id || 1,
    name: userName || currentUser?.name || 'Rev. James Mensah',
    email: userEmail || currentUser?.email || 'james@gracechapel.org',
    phone: currentUser?.phone || '+233244000001',
    role: userRole || currentUser?.role || 'Super Admin',
    church: organization || currentUser?.organization || 'Grace Chapel International',
    joined: currentUser?.joined ? new Date(currentUser.joined).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : 'January 2024',
    lastActive: currentUser?.last_active ? new Date(currentUser.last_active).toLocaleString() : 'Today at 10:30 AM',
    status: currentUser?.status || 'Active',
    avatar: null,
    bio: currentUser?.bio || 'Senior Pastor with over 15 years of ministry experience. Passionate about church growth and digital evangelism.',
    preferences: {
      language: 'English',
      timezone: 'GMT',
      dateFormat: 'MM/DD/YYYY',
      notifications: {
        email: true,
        sms: true,
        push: true
      }
    },
    security: {
      twoFactorEnabled: currentUser?.two_factor_enabled || false,
      lastPasswordChange: '2026-01-15',
      loginHistory: [
        { date: '2026-04-23 10:30:00', ip: '192.168.1.1', device: 'Chrome - Windows', location: 'Accra, Ghana' },
        { date: '2026-04-22 15:20:00', ip: '192.168.1.2', device: 'Safari - iPhone', location: 'Accra, Ghana' },
        { date: '2026-04-21 09:15:00', ip: '192.168.1.3', device: 'Firefox - Mac', location: 'Tema, Ghana' }
      ]
    },
    activityLog: [
      { id: 1, action: 'Logged in', timestamp: new Date().toLocaleString(), details: 'IP: 192.168.1.1' },
      { id: 2, action: 'Sent broadcast', timestamp: '2026-04-23 09:15:00', details: 'Sunday reminder to 1,247 members' },
      { id: 3, action: 'Updated member', timestamp: '2026-04-22 16:45:00', details: 'Edited Emmanuel Asante' },
      { id: 4, action: 'Created poll', timestamp: '2026-04-22 14:30:00', details: 'Service feedback poll' },
      { id: 5, action: 'Exported members', timestamp: '2026-04-21 11:20:00', details: 'Exported 124 members' }
    ],
    stats: {
      totalBroadcasts: 47,
      totalMembers: 1247,
      totalSMS: 68241,
      campaigns: 12
    }
  });

  // Update user state when Redux data changes
  useEffect(() => {
    if (currentUser) {
      setUser(prev => ({
        ...prev,
        id: currentUser.id || prev.id,
        name: userName || currentUser.name || prev.name,
        email: userEmail || currentUser.email || prev.email,
        phone: currentUser.phone || prev.phone,
        role: userRole || currentUser.role || prev.role,
        church: organization || currentUser.organization || prev.church,
        joined: currentUser.joined ? new Date(currentUser.joined).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : prev.joined,
        lastActive: currentUser.last_active ? new Date(currentUser.last_active).toLocaleString() : prev.lastActive,
        status: currentUser.status || prev.status,
        security: {
          ...prev.security,
          twoFactorEnabled: currentUser.two_factor_enabled || prev.security.twoFactorEnabled
        }
      }));
    }
  }, [currentUser, organization, userName, userEmail, userRole]);

  // Display API messages when they change - ONLY display the API message
  useEffect(() => {
    if (apiMessage && showToast) {
      // Only show messages that are from user actions
      // Skip "User profile retrieved successfully" and other silent messages
      const silentMessages = [
        'User profile retrieved successfully',
        'User profile retrieved',
        'Profile retrieved successfully'
      ];
      
      const shouldIgnore = silentMessages.some(silent => 
        apiMessage.toLowerCase().includes(silent.toLowerCase())
      );
      
      if (!shouldIgnore) {
        showToast(apiMessage, authError ? 'error' : 'success');
      }
      
      // Always clear the message
      setTimeout(() => {
        dispatch(clearApiMessage());
        dispatch(clearError());
      }, 5000);
    }
  }, [apiMessage, authError, dispatch, showToast]);

  // useEffect(() => {
  //   if (apiMessage) {
  //     // Only show the API message, no extra text
  //     showToast(apiMessage, authError ? 'error' : 'success');
  //     // Clear the message after displaying
  //     setTimeout(() => {
  //       dispatch(clearApiMessage());
  //       dispatch(clearError());
  //     }, 5000);
  //   }
  // }, [apiMessage, authError, dispatch, showToast]);

  // Edit form refs
  const editNameRef = useRef(null);
  const editEmailRef = useRef(null);
  const editPhoneRef = useRef(null);
  const editBioRef = useRef(null);
  const editLanguageRef = useRef(null);
  const editTimezoneRef = useRef(null);
  const editDateFormatRef = useRef(null);

  // Password change refs
  const currentPasswordRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  // State for editing
  const [editingField, setEditingField] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');
  const [showActivity, setShowActivity] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const color = getRandomColor(user.id);

  // ==================== TOAST HELPER ====================

  const showToastMessage = (message, type = 'info') => {
    if (showToast) {
      showToast(message, type);
    } else {
      // alert(message);
    }
  };

  // ==================== PROFILE ACTIONS ====================

  // Update profile - Uses Redux action
  const handleUpdateProfile = () => {
    setIsEditing(true);
    // Clear previous messages
    dispatch(clearApiMessage());
    dispatch(clearError());

    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title"><Pencil size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />Edit Profile</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            marginBottom: '16px',
            padding: '16px',
            background: 'var(--cream)',
            borderRadius: '10px'
          }}>
            <div style={{
              width: '64px',
              height: '64px',
              borderRadius: '50%',
              background: color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '24px',
              fontWeight: '700',
              color: 'white',
              flexShrink: 0
            }}>
              {getInitials(user.name)}
            </div>
            <div>
              <div style={{ fontSize: '13px', color: 'var(--text-light)' }}>Profile Photo</div>
              <button
                className="btn btn-ghost btn-sm"
                onClick={() => showToastMessage('📸 Photo upload modal opening...', 'info')}
              >
                <Camera size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Change Photo
              </button>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Full Name</label>
            <input
              className="form-input"
              ref={editNameRef}
              defaultValue={user.name}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              className="form-input"
              type="email"
              ref={editEmailRef}
              defaultValue={user.email}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Phone Number</label>
            <input
              className="form-input"
              ref={editPhoneRef}
              defaultValue={user.phone}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Bio</label>
            <textarea
              className="form-textarea"
              rows="3"
              ref={editBioRef}
              defaultValue={user.bio}
            />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Language</label>
              <select
                className="form-select"
                ref={editLanguageRef}
                defaultValue={user.preferences.language}
              >
                <option value="English">English</option>
                <option value="French">French</option>
                <option value="Spanish">Spanish</option>
                <option value="Portuguese">Portuguese</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Time Zone</label>
              <select
                className="form-select"
                ref={editTimezoneRef}
                defaultValue={user.preferences.timezone}
              >
                <option value="GMT">GMT (UTC+0)</option>
                <option value="GMT+1">GMT+1 (WAT)</option>
                <option value="GMT+2">GMT+2 (CAT)</option>
                <option value="GMT+3">GMT+3 (EAT)</option>
                <option value="GMT-5">GMT-5 (EST)</option>
              </select>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Date Format</label>
            <select
              className="form-select"
              ref={editDateFormatRef}
              defaultValue={user.preferences.dateFormat}
            >
              <option value="MM/DD/YYYY">MM/DD/YYYY</option>
              <option value="DD/MM/YYYY">DD/MM/YYYY</option>
              <option value="YYYY-MM-DD">YYYY-MM-DD</option>
            </select>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Cancel</button>
          <button
            className="btn btn-gold btn-sm"
            disabled={isSubmitting || isLoading}
            onClick={async () => {
              const name = editNameRef.current?.value?.trim() || '';
              const email = editEmailRef.current?.value?.trim() || '';
              const phone = editPhoneRef.current?.value?.trim() || '';
              const bio = editBioRef.current?.value || '';
              const language = editLanguageRef.current?.value || 'English';
              const timezone = editTimezoneRef.current?.value || 'GMT';
              const dateFormat = editDateFormatRef.current?.value || 'MM/DD/YYYY';

              if (!name) {
                showToastMessage('Please enter your name', 'error');
                return;
              }
              if (!email) {
                showToastMessage('Please enter your email', 'error');
                return;
              }

              setIsSubmitting(true);

              // Split name into first and last name
              const nameParts = name.split(' ');
              const firstName = nameParts[0] || name;
              const lastName = nameParts.slice(1).join(' ') || '';

              // Dispatch updateProfile action
              const result = await dispatch(updateProfile({
                first_name: firstName,
                last_name: lastName,
                phone: phone,
                bio: bio,
                department: user.department,
                position: user.position
              }));

              setIsSubmitting(false);

              // Only close modal and update state on success
              if (result.payload?.success) {
                // Update local state
                setUser({
                  ...user,
                  name,
                  email,
                  phone,
                  bio,
                  preferences: {
                    ...user.preferences,
                    language,
                    timezone,
                    dateFormat
                  }
                });
                setEditingField(null);
                setIsEditing(false);
                closeModal();
              }
              // If error, modal stays open and user can retry
            }}
          >
            {isSubmitting || isLoading
              ? <><Loader2 size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Saving...</>
              : <><Save size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Save Changes</>}
          </button>
        </div>
      </div>
    );
  };

  // ==================== PASSWORD ACTIONS ====================

  const handleChangePassword = () => {
    // Clear previous messages
    dispatch(clearApiMessage());
    dispatch(clearError());

    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title"><Key size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />Change Password</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Current Password</label>
            <input
              className="form-input"
              type="password"
              ref={currentPasswordRef}
              placeholder="Enter your current password"
            />
          </div>
          <div className="form-group">
            <label className="form-label">New Password</label>
            <input
              className="form-input"
              type="password"
              ref={newPasswordRef}
              placeholder="Enter new password"
            />
            <div className="form-hint">Minimum 8 characters with at least one number and special character</div>
          </div>
          <div className="form-group">
            <label className="form-label">Confirm New Password</label>
            <input
              className="form-input"
              type="password"
              ref={confirmPasswordRef}
              placeholder="Confirm new password"
            />
          </div>
          <div style={{
            padding: '12px',
            background: 'var(--blue-bg)',
            borderRadius: '8px',
            fontSize: '12px',
            color: 'var(--blue)'
          }}>
            <Lock size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Your password will be securely encrypted.
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Cancel</button>
          <button
            className="btn btn-gold btn-sm"
            disabled={isSubmitting || isLoading}
            onClick={async () => {
              const current = currentPasswordRef.current?.value || '';
              const newPass = newPasswordRef.current?.value || '';
              const confirm = confirmPasswordRef.current?.value || '';

              if (!current) {
                showToastMessage('Please enter your current password', 'error');
                return;
              }
              if (newPass.length < 8) {
                showToastMessage('Password must be at least 8 characters', 'error');
                return;
              }
              if (newPass !== confirm) {
                showToastMessage('Passwords do not match', 'error');
                return;
              }

              setIsSubmitting(true);

              // Dispatch changePassword action
              const result = await dispatch(changePassword({
                current_password: current,
                new_password: newPass,
                new_password_confirmation: confirm
              }));

              setIsSubmitting(false);

              // Only close modal on success
              if (result.payload?.success) {
                setUser({
                  ...user,
                  security: {
                    ...user.security,
                    lastPasswordChange: new Date().toISOString().split('T')[0]
                  }
                });
                closeModal();
              }
              // If error, modal stays open and user can retry
            }}
          >
            {isSubmitting || isLoading
              ? <><Loader2 size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Changing...</>
              : <><Key size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Change Password</>}
          </button>
        </div>
      </div>
    );
  };

  // ==================== TWO-FACTOR AUTHENTICATION ====================

  const handleToggle2FA = () => {
    const isEnabled = user.security.twoFactorEnabled;
    // Clear previous messages
    dispatch(clearApiMessage());
    dispatch(clearError());

    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title">{isEnabled ? <Lock size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} /> : <Unlock size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />}Two-Factor Authentication</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <div style={{
            textAlign: 'center',
            padding: '20px 0'
          }}>
            <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'center' }}>
              {isEnabled ? <Lock size={48} strokeWidth={1.5} /> : <Unlock size={48} strokeWidth={1.5} />}
            </div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: 'var(--navy)' }}>
              {isEnabled ? 'Disable Two-Factor Authentication?' : 'Enable Two-Factor Authentication?'}
            </div>
            <p style={{ fontSize: '13px', color: 'var(--text-mid)', marginTop: '8px' }}>
              {isEnabled
                ? 'This will remove an extra layer of security from your account.'
                : 'This will add an extra layer of security to your account.'}
            </p>
            <div style={{
              marginTop: '16px',
              padding: '12px',
              background: isEnabled ? 'var(--red-bg)' : 'var(--green-bg)',
              borderRadius: '8px',
              fontSize: '13px',
              color: isEnabled ? 'var(--red)' : 'var(--green)'
            }}>
              {isEnabled
                ? <><AlertTriangle size={13} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Your account will be less secure without 2FA.</>
                : <><CheckCircle2 size={13} style={{ verticalAlign: '-2px', marginRight: '4px' }} />You will need to verify your identity using an authenticator app.</>}
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Phone Number (for SMS verification)</label>
            <input
              className="form-input"
              defaultValue={user.phone}
              placeholder="+233244123456"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Cancel</button>
          <button
            className={`btn ${isEnabled ? 'btn-danger' : 'btn-gold'}`}
            disabled={isSubmitting || isLoading}
            onClick={async () => {
              setIsSubmitting(true);

              // Dispatch toggleTwoFactor action
              const result = await dispatch(toggleTwoFactor());

              setIsSubmitting(false);

              // Only close modal on success
              if (result.payload?.success) {
                const newState = !isEnabled;
                setUser({
                  ...user,
                  security: {
                    ...user.security,
                    twoFactorEnabled: newState
                  }
                });
                closeModal();
              }
              // If error, modal stays open and user can retry
            }}
          >
            {isSubmitting || isLoading
              ? <><Loader2 size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Toggling...</>
              : (isEnabled ? 'Disable 2FA' : 'Enable 2FA')}
          </button>
        </div>
      </div>
    );
  };

  // ==================== NOTIFICATION PREFERENCES ====================

  const handleNotificationToggle = (type) => {
    setUser({
      ...user,
      preferences: {
        ...user.preferences,
        notifications: {
          ...user.preferences.notifications,
          [type]: !user.preferences.notifications[type]
        }
      }
    });
    showToastMessage(`🔔 ${type.charAt(0).toUpperCase() + type.slice(1)} notifications ${user.preferences.notifications[type] ? 'disabled' : 'enabled'}`, 'info');
  };

  // ==================== EXPORT ACTIONS ====================

  const handleExportData = () => {
    const data = {
      profile: {
        name: user.name,
        email: user.email,
        phone: user.phone,
        role: user.role,
        church: user.church,
        joined: user.joined,
        status: user.status,
        bio: user.bio
      },
      preferences: user.preferences,
      security: {
        twoFactorEnabled: user.security.twoFactorEnabled,
        lastPasswordChange: user.security.lastPasswordChange
      },
      stats: user.stats,
      activityLog: user.activityLog
    };

    const fields = [
      { key: 'name', label: 'Name' },
      { key: 'email', label: 'Email' },
      { key: 'phone', label: 'Phone' },
      { key: 'role', label: 'Role' },
      { key: 'church', label: 'Church' },
      { key: 'joined', label: 'Joined' },
      { key: 'status', label: 'Status' },
      { key: 'totalBroadcasts', label: 'Total Broadcasts' },
      { key: 'totalMembers', label: 'Total Members' },
      { key: 'totalSMS', label: 'Total SMS' },
      { key: 'campaigns', label: 'Campaigns' }
    ];

    const exportData = [{
      ...data.profile,
      ...data.stats
    }];

    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title"><Download size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />Export Profile Data</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <div style={{ fontSize: '13px', color: 'var(--text-mid)', marginBottom: '16px' }}>
            Export your profile data and statistics.
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
            {['CSV', 'JSON', 'Excel', 'PDF'].map(format => (
              <button
                key={format}
                className="btn btn-ghost btn-sm"
                onClick={() => {
                  const formattedData = formatForExport(exportData, fields);
                  const filename = getExportFilename('user-profile');

                  switch (format) {
                    case 'CSV':
                      exportToCSV(formattedData, filename);
                      break;
                    case 'JSON':
                      exportToJSON(data, filename);
                      break;
                    case 'Excel':
                      exportToExcel(formattedData, filename);
                      break;
                    case 'PDF':
                      exportToPDF(formattedData, 'User Profile Report', filename);
                      break;
                    default:
                      showToastMessage('Export format not supported', 'error');
                      return;
                  }
                  showToastMessage(`📥 Profile exported as ${format}!`, 'success');
                  closeModal();
                }}
                style={{
                  padding: '8px',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '4px',
                  height: 'auto',
                  border: '2px solid var(--border)',
                  borderRadius: '8px',
                  transition: 'all 0.2s',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'var(--gold)';
                  e.currentTarget.style.background = 'var(--gold-pale)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'var(--border)';
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                <span style={{ display: 'flex' }}>
                  {format === 'CSV' && <BarChart3 size={20} />}
                  {format === 'JSON' && <ClipboardList size={20} />}
                  {format === 'Excel' && <TrendingUp size={20} />}
                  {format === 'PDF' && <FileText size={20} />}
                </span>
                <span style={{ fontSize: '11px' }}>{format}</span>
              </button>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Cancel</button>
        </div>
      </div>
    );
  };

  // ==================== ACTIVITY LOG ACTIONS ====================

  const handleViewActivityDetails = (activity) => {
    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title"><ClipboardList size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />Activity Details</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <div style={{ display: 'grid', gap: '12px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px', fontSize: '13px' }}>
              <span style={{ color: 'var(--text-light)', fontWeight: '500' }}>Action</span>
              <span style={{ fontWeight: '600' }}>{activity.action}</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px', fontSize: '13px' }}>
              <span style={{ color: 'var(--text-light)', fontWeight: '500' }}>Time</span>
              <span>{activity.timestamp}</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '8px', fontSize: '13px' }}>
              <span style={{ color: 'var(--text-light)', fontWeight: '500' }}>Details</span>
              <span style={{ color: 'var(--text-mid)' }}>{activity.details}</span>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Close</button>
        </div>
      </div>
    );
  };

  const handleClearActivity = () => {
    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title"><Trash2 size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />Clear Activity Log</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <p style={{ fontSize: '14px', color: 'var(--text-mid)', marginBottom: '16px' }}>
            Are you sure you want to clear your activity log?
          </p>
          <div style={{
            padding: '12px',
            background: 'var(--red-bg)',
            borderRadius: '8px',
            fontSize: '13px',
            color: 'var(--red)'
          }}>
            <AlertTriangle size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />This action cannot be undone.
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Cancel</button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => {
              setUser({
                ...user,
                activityLog: []
              });
              showToastMessage('🗑️ Activity log cleared', 'error');
              closeModal();
            }}
          >
            Clear All
          </button>
        </div>
      </div>
    );
  };

  // ==================== DEACTIVATE ACCOUNT ====================

  const handleDeactivateAccount = () => {
    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title"><AlertTriangle size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />Deactivate Account</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <div style={{
            textAlign: 'center',
            padding: '20px 0'
          }}>
            <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'center' }}><AlertTriangle size={48} strokeWidth={1.5} /></div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: 'var(--red)' }}>
              Are you sure you want to deactivate your account?
            </div>
            <p style={{ fontSize: '14px', color: 'var(--text-mid)', marginTop: '8px' }}>
              Your account will be temporarily disabled. You can reactivate it at any time.
            </p>
            <div style={{
              marginTop: '16px',
              padding: '12px',
              background: 'var(--red-bg)',
              borderRadius: '8px',
              fontSize: '13px',
              color: 'var(--red)'
            }}>
              <AlertTriangle size={13} style={{ verticalAlign: '-2px', marginRight: '4px' }} />You will not be able to access the platform until reactivated.
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Cancel</button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => {
              dispatch(clearAuthState());
              showToastMessage('⚠️ Account deactivated', 'error');
              closeModal();
              navigate('/login');
            }}
          >
            Deactivate Account
          </button>
        </div>
      </div>
    );
  };

  // ==================== LOGIN HISTORY ====================

  const handleViewLoginHistory = () => {
    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title"><Clock size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />Login History</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {user.security.loginHistory.map((login, index) => (
              <div key={index} style={{
                padding: '10px',
                borderBottom: '1px solid var(--border-light)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '8px'
              }}>
                <div>
                  <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
                    {login.device}
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
                    {login.location} · {login.ip}
                  </div>
                </div>
                <div style={{ fontSize: '12px', color: 'var(--text-mid)', textAlign: 'right' }}>
                  {login.date}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Close</button>
        </div>
      </div>
    );
  };

  // ==================== EXPORT ACTIVITY ====================

  const handleExportActivity = () => {
    if (user.activityLog.length === 0) {
      showToastMessage('No activity to export', 'error');
      return;
    }

    const fields = [
      { key: 'action', label: 'Action' },
      { key: 'timestamp', label: 'Timestamp' },
      { key: 'details', label: 'Details' }
    ];

    const formattedData = formatForExport(user.activityLog, fields);
    const filename = getExportFilename('user-activity');
    exportToCSV(formattedData, filename);
    showToastMessage(`📥 ${user.activityLog.length} activities exported`, 'success');
  };

  // ==================== LOGOUT ====================

  const handleLogout = () => {
    openModal(
      <div>
        <div className="modal-header">
          <div className="modal-title"><LogOut size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />Logout</div>
          <button className="modal-close" onClick={closeModal}>×</button>
        </div>
        <div className="modal-body">
          <div style={{
            textAlign: 'center',
            padding: '20px 0'
          }}>
            <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'center' }}><Hand size={48} strokeWidth={1.5} /></div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: 'var(--navy)' }}>
              Are you sure you want to logout?
            </div>
            <p style={{ fontSize: '14px', color: 'var(--text-mid)', marginTop: '8px' }}>
              You will be redirected to the login page.
            </p>
            <div style={{
              marginTop: '16px',
              padding: '12px',
              background: 'var(--cream)',
              borderRadius: '8px',
              fontSize: '13px',
              color: 'var(--text-mid)'
            }}>
              Your session will be securely ended.
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost btn-sm" onClick={closeModal}>Cancel</button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => {
              dispatch(logoutUser());
              closeModal();
              navigate('/login');
              showToastMessage('👋 Logged out successfully', 'info');
            }}
          >
            Logout
          </button>
        </div>
      </div>
    );
  };

  // Format status badge class
  const getStatusBadgeClass = (status) => {
    if (!status) return 'badge-amber';
    switch(status.toLowerCase()) {
      case 'active': return 'badge-green';
      case 'inactive': return 'badge-red';
      default: return 'badge-amber';
    }
  };

  return (
    <div className="grid-2" style={{ gap: '20px' }}>
      {/* Left Column - Profile Card */}
      <div>
        <div className="card">
          <div className="card-header">
            <div className="card-title">Profile</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <button className="btn btn-ghost btn-sm" onClick={handleExportData}>
                <Download size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Export
              </button>
              <button className="btn btn-gold btn-sm" onClick={handleUpdateProfile}>
                <Pencil size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Edit
              </button>
            </div>
          </div>

          {/* Profile Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            padding: '16px',
            background: 'var(--cream)',
            borderRadius: '10px',
            marginBottom: '16px'
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '32px',
              fontWeight: '700',
              color: 'white',
              flexShrink: 0
            }}>
              {getInitials(user.name)}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '20px', fontWeight: '700', color: 'var(--navy)' }}>
                {user.name}
              </div>
              <div style={{ fontSize: '13px', color: 'var(--text-mid)' }}>
                {user.role} · {user.church}
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '4px', flexWrap: 'wrap' }}>
                <span className={`badge ${getStatusBadgeClass(user.status)}`}>
                  {user.status}
                </span>
                <span className="badge badge-blue">
                  Last active: {user.lastActive}
                </span>
                {loginCount > 0 && (
                  <span className="badge badge-amber">
                    Logins: {loginCount}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Profile Details */}
          <div style={{ marginBottom: '16px' }}>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '10px'
            }}>
              {[
                [Mail, 'Email', user.email],
                [Phone, 'Phone', formatPhoneNumber(user.phone)],
                [Church, 'Church', user.church],
                [Calendar, 'Joined', user.joined],
                [Key, 'Role', user.role],
                [Clock, 'Last Active', user.lastActive]
              ].map(([Icon, label, value]) => (
                <div key={label} style={{
                  padding: '10px 12px',
                  background: 'var(--cream)',
                  borderRadius: '8px'
                }}>
                  <div style={{ fontSize: '10px', color: 'var(--text-light)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    <Icon size={11} style={{ verticalAlign: '-2px', marginRight: '3px' }} />{label}
                  </div>
                  <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)', marginTop: '2px' }}>
                    {value}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bio */}
          <div style={{
            padding: '12px',
            background: 'var(--cream)',
            borderRadius: '8px',
            marginBottom: '16px'
          }}>
            <div style={{ fontSize: '11px', color: 'var(--text-light)', marginBottom: '4px', fontWeight: '600' }}>
              <NotebookPen size={11} style={{ verticalAlign: '-2px', marginRight: '3px' }} />Bio
            </div>
            <div style={{ fontSize: '13px', color: 'var(--text-mid)', lineHeight: '1.6' }}>
              {user.bio}
            </div>
          </div>

          {/* Quick Actions */}
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button className="btn btn-ghost btn-sm" onClick={handleChangePassword}>
              <Key size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Change Password
            </button>
            <button className="btn btn-ghost btn-sm" onClick={handleToggle2FA}>
              {user.security.twoFactorEnabled ? <Lock size={14} style={{ verticalAlign: '-2px' }} /> : <Unlock size={14} style={{ verticalAlign: '-2px' }} />} {user.security.twoFactorEnabled ? '2FA On' : '2FA Off'}
            </button>
            <button className="btn btn-danger btn-sm" onClick={handleDeactivateAccount}>
              <AlertTriangle size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Deactivate
            </button>
            <button className="btn btn-danger btn-sm" onClick={handleLogout}>
              <LogOut size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Logout
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="card" style={{ marginTop: '16px' }}>
          <div className="card-title" style={{ marginBottom: '14px' }}><BarChart3 size={16} style={{ verticalAlign: '-3px' }} /> Statistics</div>
          <div className="stats-grid" style={{ gap: '10px' }}>
            <div className="stat-card gold" style={{ padding: '12px' }}>
              <div className="stat-label">Broadcasts</div>
              <div className="stat-value">{user.stats.totalBroadcasts}</div>
              <div className="stat-icon"><Megaphone size={20} /></div>
            </div>
            <div className="stat-card green" style={{ padding: '12px' }}>
              <div className="stat-label">Members</div>
              <div className="stat-value">{user.stats.totalMembers.toLocaleString()}</div>
              <div className="stat-icon"><Users size={20} /></div>
            </div>
            <div className="stat-card blue" style={{ padding: '12px' }}>
              <div className="stat-label">SMS Sent</div>
              <div className="stat-value">{user.stats.totalSMS.toLocaleString()}</div>
              <div className="stat-icon"><Send size={20} /></div>
            </div>
            <div className="stat-card purple" style={{ padding: '12px' }}>
              <div className="stat-label">Campaigns</div>
              <div className="stat-value">{user.stats.campaigns}</div>
              <div className="stat-icon"><Rocket size={20} /></div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column - Settings & Activity */}
      <div>
        {/* Notification Preferences */}
        <div className="card" style={{ marginBottom: '16px' }}>
          <div className="card-title" style={{ marginBottom: '14px' }}><Bell size={16} style={{ verticalAlign: '-3px' }} /> Notification Preferences</div>
          {[
            { key: 'email', label: 'Email Notifications', icon: Mail },
            { key: 'sms', label: 'SMS Notifications', icon: Smartphone },
            { key: 'push', label: 'Push Notifications', icon: Bell }
          ].map((item) => (
            <div key={item.key} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 0',
              borderBottom: '1px solid var(--border-light)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <item.icon size={20} />
                <span style={{ fontSize: '13px', color: 'var(--text)' }}>{item.label}</span>
              </div>
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={user.preferences.notifications[item.key]}
                  onChange={() => handleNotificationToggle(item.key)}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>
          ))}
          <div style={{ marginTop: '12px' }}>
            <button className="btn btn-ghost btn-sm" onClick={() => {
              setUser({
                ...user,
                preferences: {
                  ...user.preferences,
                  notifications: {
                    email: true,
                    sms: true,
                    push: true
                  }
                }
              });
              showToastMessage('✅ All notifications enabled', 'success');
            }}>
              Enable All
            </button>
            <button className="btn btn-ghost btn-sm" style={{ marginLeft: '8px' }} onClick={() => {
              setUser({
                ...user,
                preferences: {
                  ...user.preferences,
                  notifications: {
                    email: false,
                    sms: false,
                    push: false
                  }
                }
              });
              showToastMessage('🔕 All notifications disabled', 'info');
            }}>
              Disable All
            </button>
          </div>
        </div>

        {/* Security */}
        <div className="card" style={{ marginBottom: '16px' }}>
          <div className="card-title" style={{ marginBottom: '14px' }}><ShieldCheck size={16} style={{ verticalAlign: '-3px' }} /> Security</div>
          <div style={{ display: 'grid', gap: '10px' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 12px',
              background: 'var(--cream)',
              borderRadius: '8px'
            }}>
              <div>
                <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
                  Two-Factor Authentication
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
                  {user.security.twoFactorEnabled
                    ? <><CheckCircle2 size={12} style={{ verticalAlign: '-2px' }} /> Enabled</>
                    : <><XCircle size={12} style={{ verticalAlign: '-2px' }} /> Disabled</>}
                </div>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={handleToggle2FA}>
                {user.security.twoFactorEnabled ? 'Disable' : 'Enable'}
              </button>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 12px',
              background: 'var(--cream)',
              borderRadius: '8px'
            }}>
              <div>
                <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
                  Last Password Change
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
                  {user.security.lastPasswordChange}
                </div>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={handleChangePassword}>
                Change
              </button>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 12px',
              background: 'var(--cream)',
              borderRadius: '8px'
            }}>
              <div>
                <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
                  Login History
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
                  {user.security.loginHistory.length} sessions
                </div>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={handleViewLoginHistory}>
                View All
              </button>
            </div>
            {permissions && permissions.length > 0 && (
              <div style={{
                padding: '10px 12px',
                background: 'var(--cream)',
                borderRadius: '8px'
              }}>
                <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
                  Permissions
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
                  {permissions.map((perm, index) => (
                    <span key={index} style={{
                      padding: '2px 8px',
                      background: 'var(--navy)',
                      color: 'var(--gold-light)',
                      borderRadius: '4px',
                      fontSize: '10px',
                      fontFamily: 'JetBrains Mono, monospace'
                    }}>
                      {perm}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Activity Log */}
        <div className="card">
          <div className="card-header">
            <div className="card-title"><ClipboardList size={16} style={{ verticalAlign: '-3px' }} /> Activity Log</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {user.activityLog.length > 0 && (
                <>
                  <button className="btn btn-ghost btn-sm" onClick={handleExportActivity}>
                    <Download size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Export
                  </button>
                  <button className="btn btn-ghost btn-sm" onClick={handleClearActivity} style={{ color: 'var(--red)' }}>
                    <Trash2 size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Clear
                  </button>
                </>
              )}
            </div>
          </div>
          {user.activityLog.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '30px 0', color: 'var(--text-light)' }}>
              <div style={{ marginBottom: '8px', display: 'flex', justifyContent: 'center' }}><Inbox size={40} strokeWidth={1.5} /></div>
              <div>No activity yet</div>
            </div>
          ) : (
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {user.activityLog.slice(0, 5).map((activity) => (
                <div key={activity.id} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '10px 0',
                  borderBottom: '1px solid var(--border-light)',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'var(--cream)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                onClick={() => handleViewActivityDetails(activity)}
                >
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: 'var(--navy)',
                    color: 'var(--gold-light)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    flexShrink: 0
                  }}>
                    {activity.action.charAt(0)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
                      {activity.action}
                    </div>
                    <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
                      {activity.timestamp}
                    </div>
                  </div>
                  <button
                    className="btn btn-ghost btn-sm btn-icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewActivityDetails(activity);
                    }}
                    title="View Details"
                  >
                    <Eye size={14} />
                  </button>
                </div>
              ))}
              {user.activityLog.length > 5 && (
                <div style={{ textAlign: 'center', padding: '8px 0' }}>
                  <button
                    className="btn btn-ghost btn-sm"
                    onClick={() => {
                      openModal(
                        <div>
                          <div className="modal-header">
                            <div className="modal-title"><ClipboardList size={16} style={{ verticalAlign: '-3px', marginRight: '6px' }} />All Activities</div>
                            <button className="modal-close" onClick={closeModal}>×</button>
                          </div>
                          <div className="modal-body">
                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                              {user.activityLog.map((activity) => (
                                <div key={activity.id} style={{
                                  padding: '10px',
                                  borderBottom: '1px solid var(--border-light)',
                                  cursor: 'pointer'
                                }}
                                onClick={() => {
                                  closeModal();
                                  setTimeout(() => handleViewActivityDetails(activity), 100);
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = 'var(--cream)'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                >
                                  <div style={{ fontSize: '13px', fontWeight: '500', color: 'var(--navy)' }}>
                                    {activity.action}
                                  </div>
                                  <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>
                                    {activity.timestamp}
                                  </div>
                                  <div style={{ fontSize: '11px', color: 'var(--text-mid)' }}>
                                    {activity.details}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button className="btn btn-ghost btn-sm" onClick={closeModal}>Close</button>
                            {user.activityLog.length > 0 && (
                              <button className="btn btn-ghost btn-sm" onClick={handleExportActivity}>
                                <Download size={14} style={{ verticalAlign: '-2px', marginRight: '4px' }} />Export All
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    }}
                  >
                    View All ({user.activityLog.length})
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <style>{`
        .badge {
          padding: 3px 10px;
          border-radius: 12px;
          font-size: 11px;
          font-weight: 500;
          display: inline-block;
        }
        .badge-green {
          background: var(--green-bg);
          color: var(--green);
        }
        .badge-red {
          background: var(--red-bg);
          color: var(--red);
        }
        .badge-blue {
          background: var(--blue-bg);
          color: var(--blue);
        }
        .badge-amber {
          background: var(--amber-bg);
          color: var(--amber);
        }
        .badge-purple {
          background: var(--purple-bg);
          color: var(--purple);
        }
        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          flex-wrap: wrap;
          gap: 10px;
        }
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
        }
        .stat-card {
          padding: 12px;
          border-radius: 10px;
          position: relative;
          overflow: hidden;
        }
        .stat-card .stat-label {
          font-size: 11px;
          color: var(--text-light);
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .stat-card .stat-value {
          font-size: 20px;
          font-weight: 700;
          font-family: Playfair Display, serif;
          color: var(--navy);
          margin-top: 2px;
        }
        .stat-card .stat-icon {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 28px;
          opacity: 0.3;
        }
        .stat-card.gold { background: var(--gold-pale); }
        .stat-card.green { background: var(--green-bg); }
        .stat-card.blue { background: var(--blue-bg); }
        .stat-card.purple { background: var(--purple-bg); }
        .toggle {
          position: relative;
          display: inline-block;
          width: 40px;
          height: 22px;
          flex-shrink: 0;
        }
        .toggle input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        .toggle-slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: #ccc;
          transition: 0.3s;
          border-radius: 22px;
        }
        .toggle-slider:before {
          position: absolute;
          content: "";
          height: 16px;
          width: 16px;
          left: 3px;
          bottom: 3px;
          background: white;
          transition: 0.3s;
          border-radius: 50%;
        }
        .toggle input:checked + .toggle-slider {
          background: var(--gold);
        }
        .toggle input:checked + .toggle-slider:before {
          transform: translateX(18px);
        }
        @media (max-width: 768px) {
          .grid-2 {
            grid-template-columns: 1fr !important;
          }
          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .card-header {
            flex-direction: column;
            align-items: flex-start !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Profile;